/** under window key */
export const CobrowserKey = "__auvious_cobrowser";
